import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useLocation } from 'react-router';

interface BackButtonProps {
  className?: string;
  variant?: "default" | "outline" | "ghost" | "secondary";
  size?: "default" | "sm" | "lg";
  fallbackRoute?: string;
}

export function BackButton({ 
  className = "", 
  variant = "outline", 
  size = "default",
  fallbackRoute = "/"
}: BackButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    const urlParams = new URLSearchParams(location.search);
    const from = urlParams.get('from');
    if (from) { navigate(from); return; }

    const currentPath = location.pathname;
    if (currentPath === '/my-bookings') {
      navigate('/dashboard');
    } else if (currentPath.startsWith('/services/') || currentPath.includes('childcare') ||
        currentPath.includes('cleaning') || currentPath.includes('tutoring') ||
        currentPath.includes('pet-care') || currentPath.includes('elderly-care')) {
      navigate('/booking-flow');
    } else if (currentPath === '/become-helper') {
      navigate('/');
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackRoute);
    }
  };

  return (
    <Button 
      variant={variant} 
      size={size}
      onClick={handleBack}
      className={`flex items-center gap-2 ${className}`}
    >
      <ArrowLeft className="h-4 w-4" />
      Back
    </Button>
  );
}